import Select from "./Select";
import { useFormikContext } from "formik";
import TextInput from "./TextInput";
import useBanks from "../../hooks/use-banks";
import Card from "./Card";

export default function SelectIban({ dependon = "id_parent" }) {
  const { banks } = useBanks();
  const { setFieldValue } = useFormikContext();
  return (
    <Card className={"marginB10"} padding={"sm"}>
      {banks?.length > 0 && (
        <Select
          dependon={dependon}
          name="select_iban"
          onChange={(e) => {
            setFieldValue("iban", e.target.value);
          }}
        >
          <option value="">Selectionnez une banque ou entrez l'IBAN</option>
          {banks.map((bank) => (
            <option key={bank.id} value={bank.iban.toUpperCase()}>
              {bank.nom ? bank.nom : bank.bank_metadata.name}
            </option>
          ))}
        </Select>
      )}

      <TextInput
        type="text"
        name="iban"
        dependon={dependon}
        label={banks?.length === 0 ? "IBAN" : ""}
        transformValue={(v) => v.toUpperCase()}
      />
      <TextInput
        type="text"
        name="iban_titulaire"
        dependon={dependon}
        label="Titulaire du compte"
        placeholder="Par défaut : le nom du profil bailleur"
      />
    </Card>
  );
}
